import { render } from "./IconNode.vue?vue&type=template&id=48ccbe79"
import script from "./IconNode.vue?vue&type=script&lang=ts"
export * from "./IconNode.vue?vue&type=script&lang=ts"
script.render = render

export default script